import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutePath } from './Routes';
import { LegalPages, Page } from '../components/legal-pages/LegalPages';

export const UnauthenticatedRouter = () => (
    <Routes>
        <Route path={RoutePath.CONTACT_DETAILS} element={<LegalPages page={Page.CONTACT_DETAILS} />} />
        <Route path={RoutePath.TERMS_AND_CONDITIONS} element={<LegalPages page={Page.TERMS_AND_CONDITIONS} />} />
        <Route path={RoutePath.PRIVACY_POLICY} element={<LegalPages page={Page.PRIVACY_POLICY} />} />
        <Route path={RoutePath.ACCEPTABLE_USE_POLICY} element={<LegalPages page={Page.ACCEPTABLE_USE} />} />
        <Route
            path="*"
            element={<Navigate to={RoutePath.LOGIN} replace state={{ path: window.location.pathname }} />}
        />
    </Routes>
);
